import { DayType } from './../types/Day';
import { DateType } from './../types/Date';
import { DatePositionType } from './../types/DatePosition';
import { MONTH } from './../constants';
import { formatDateString } from './../../../utils/helpers';

const getTotalDays = (month: number, year: number): number => {
  return 32 - new Date(year, month, 32).getDate();
};

const isNotDateRange = (year: number, month: number, day: number, minDate?: Date, maxDate?: Date): boolean => {
  return (maxDate < new Date(year, month, day) || new Date(year, month, day) < minDate);
};

export const getDaysByMonth = (month: number, year: number, minDate?: Date, maxDate?: Date): DayType[] => {
  const daysMonth = [];
  const prevMonthDay: Date = new Date(year, month, 1 - new Date(year, month, 1).getDay());
  let daysPrevMonth: number = prevMonthDay.getDate();
  let initialDay: number = 1;
  let daysNextMonth: number = 1;
  const weekDays: number = 6;
  const rowsByMonth: number = 7;
  const firstDay: number = new Date(year, month).getDay();

  for(let i = 0; i < weekDays; i++) {
    for(let j = 0; j < rowsByMonth; j++) {
      if(i === 0 && j < firstDay) {
        daysMonth.push({
          position: 'prev',
          disabled: isNotDateRange(year, month - 1, daysPrevMonth, minDate, maxDate)
        });
        daysPrevMonth++;
        continue;
      }
      if(initialDay > getTotalDays(month, year)) {
        daysMonth.push({
          position: 'next',
          disabled: isNotDateRange(year, month + 1, daysNextMonth, minDate, maxDate)
        });
        daysNextMonth++;
        continue;
      }
      daysMonth.push({
        dayMonth: initialDay,
        position: 'current',
        disabled: isNotDateRange(year, month, initialDay, minDate, maxDate)
      });
      initialDay++;
    }
  }
  return daysMonth;
};

export const getPrevDate = ({ month, year }: DateType): DateType => {
  if(month > MONTH.FIRST) {
    return {
      month: month - 1,
      year
    }
  }
  return {
    month: MONTH.LAST,
    year: year - 1
  }
};

export const getNextDate = ({ month, year }: DateType): DateType => {
  if(month < MONTH.LAST) {
    return {
      month: month + 1,
      year
    };
  }
  return {
    month: MONTH.FIRST,
    year: year + 1
  };
};

export const getDateByPosition: DatePositionType = {
  current: (day, month, year) => formatDateString(day, month, year)
};
